import { combineLatest, from } from "rxjs";
import { map, switchMap, first } from "rxjs/operators";
import { resolveHtmlContentCalculations } from "../../lib/calculations";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { ReceiptContentSettings } from "@cs-ts/receipt-content-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { useMainStore } from "@/mainStore";
import { KnownFeatureFlags } from "@cs/KnownFeatureFlags";

export default class ReceiptContentDef extends BaseElementDef<ReceiptContentSettings, FormDefinitionItem<ReceiptContentSettings>, FormItem> {
    declare isCustomReceiptContent: boolean;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<ReceiptContentSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.isCustomReceiptContent = true;
    }

    visible() {
        if (this.definition.settings.conditionalCalculationId == null && (this.definition.settings.legacyConditionalCalculation || []).length == 0) {
            return Promise.resolve(true);
        }
        const result = this.resolveCalculation(this.definition.settings.conditionalCalculationId!, this.definition.settings.legacyConditionalCalculation);
        return result
            .pipe(
                map(conditionalItems => {
                    const match = conditionalItems.some(v => this.definition.settings.conditionalValuesToMatch!.indexOf(v) >= 0);
                    return match != !!this.definition.settings.conditionalInvert;
                }),
            )
            .pipe(first())
            .toPromise();
    }

    receiptContents() {
        const htmlContent = this.definition.settings.htmlContent;
        if (this.definition.settings.htmlContentCalculationId == null && (this.definition.settings.htmlCalculations || []).length == 0 && (this.definition.settings.legacyHtmlContentCalculation || []).length == 0) {
            return Promise.resolve([htmlContent]);
        } else if ((this.definition.settings.htmlCalculations || []).length != 0) {
            return from(useMainStore().isFeatureFlagActiveAsync(KnownFeatureFlags.UseHtmlDirectId.Id))
                .pipe(
                    switchMap(useHtmlDirectId => {
                        const htmlCalculations$ = [];
                        for (const htmlCalculation of this.definition.settings.htmlCalculations ?? []) {
                            htmlCalculations$.push(this.resolveCalculation(htmlCalculation.calculationId!).pipe(map(text => ({ id: useHtmlDirectId ? htmlCalculation.id ?? htmlCalculation.calculationId : htmlCalculation.calculationId, text }))));
                        }
                        return combineLatest(htmlCalculations$).pipe(map(calculations => resolveHtmlContentCalculations(calculations, htmlContent)));
                    }),
                    first(),
                )
                .toPromise();
        } else {
            return this.resolveCalculationPromise(this.definition.settings.htmlContentCalculationId!, this.definition.settings.legacyHtmlContentCalculation);
        }
    }
}
